module.exports = __webpack_public_path__ + "img/17.8b9bc3dd.png";